module.exports = __webpack_public_path__ + "img/bg10.d8e57844.png";